// extracted by mini-css-extract-plugin
export default {"action-item":"styles_action-item__2i3Hb","menu-root":"styles_menu-root__q6qBP","menu-paper":"styles_menu-paper__dZw2N"};